var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "rankingbox", staticClass: "ranking-list" },
    [
      _c("div", { staticClass: "top-three-box" }, [
        _c("p", { staticClass: "back", on: { click: _vm.goback } }),
        _vm._v(" "),
        _c("div", { staticClass: "top-pklogo" }),
        _vm._v(" "),
        _c("div", {
          staticClass: "rewardrules-enter",
          attrs: { alt: "" },
          on: { click: _vm.gopage }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "top-ranking" },
          _vm._l(_vm.prizeList, function(item) {
            return _c(
              "div",
              { key: item.level, staticClass: "top-rankingItem" },
              [
                _c("img", { attrs: { src: item.coverImg, alt: "" } }),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(item.prizeName))])
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ranking-box" }, [
        _c("div", { staticClass: "person-infos" }, [
          _vm.uncommitted[0] && _vm.uncommitted[0].state == "0"
            ? _c("div", { staticClass: "uncommitted" }, [
                _c("div", { staticClass: "activity-time" }, [
                  _vm.acquisitionTime != 1
                    ? _c("span", [
                        _vm._v(
                          "活动时间为 " +
                            _vm._s(_vm.startTime[0]) +
                            "~" +
                            _vm._s(_vm.endTime[0])
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.acquisitionTime == 1
                    ? _c("span", { staticClass: "tips" }, [
                        _vm._v("未参与PK赛，暂无排名")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.acquisitionTime == 1
                    ? _c(
                        "span",
                        {
                          staticClass: "join-btn",
                          on: { click: _vm.popupShow }
                        },
                        [_vm._v("参与")]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "division" }),
                _vm._v(" "),
                _c("div", { staticClass: "uncommitted-container" }, [
                  _c("div", { staticClass: "ucontainer-left" }, [
                    _c("img", {
                      attrs: {
                        src:
                          _vm.uncommitted[0].coverImg ||
                          require("../assets/img/default-coverimg.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "name" }, [
                      _vm._v(
                        _vm._s(
                          _vm.uncommitted[0].nickName ||
                            "用户" + _vm.openId.substring(_vm.openId.length - 6)
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(0)
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.uncommitted[0] && _vm.uncommitted[0].state != 0
            ? _c("div", { staticClass: "participated" }, [
                _c("div", { staticClass: "participated-top" }, [
                  _vm.acquisitionTime == 3 || _vm.acquisitionTime == 4
                    ? _c("div", [
                        _c("div", { staticClass: "activity-time" }, [
                          _c("span", [
                            _vm._v(
                              "活动时间为 " +
                                _vm._s(_vm.startTime[0]) +
                                "~" +
                                _vm._s(_vm.endTime[0])
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "division" })
                      ])
                    : _c("div", { staticClass: "pratLenf-Container" }, [
                        _c("div", { staticClass: "partLeft" }, [
                          _c("img", {
                            attrs: {
                              src: require("../assets/img/jiangbei.png"),
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.uncommitted[0].rank))])
                        ]),
                        _vm._v(" "),
                        _vm.uncommitted[0].orderNum !== 1
                          ? _c("div", { staticClass: "partRight" })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.uncommitted[0].gap &&
                        _vm.list &&
                        _vm.uncommitted[0].orderNum !== 1
                          ? _c("p", { staticClass: "partRight-text" }, [
                              _vm.uncommitted[0].orderNum > 1 &&
                              _vm.uncommitted[0].orderNum < 201
                                ? _c("span", [_vm._v("距离第1名还需")])
                                : _vm.uncommitted[0].orderNum > 200 &&
                                  _vm.uncommitted[0].orderNum < 1201
                                ? _c("span", [_vm._v("距离第200名还需")])
                                : _vm.uncommitted[0].orderNum > 1200 &&
                                  _vm.uncommitted[0].orderNum < 11201
                                ? _c("span", [_vm._v("距离第1200名还需")])
                                : _vm.uncommitted[0].orderNum > 11200 &&
                                  _vm.uncommitted[0].orderNum < 31201
                                ? _c("span", [_vm._v("距离第11200名还需")])
                                : _c("span", [_vm._v("距离四等奖还需")]),
                              _vm._v(" "),
                              _c("span", { staticClass: "prize-num" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.uncommitted[0].gap == 0
                                        ? 1
                                        : _vm.tranNumber(
                                            _vm.uncommitted[0].gap || 0,
                                            1
                                          )
                                    ) +
                                    " "
                                )
                              ]),
                              _vm._v("个赞\n                    ")
                            ])
                          : _c("p", { staticClass: "partRight-text" }, [
                              _c("span", [_vm._v("距离第1名还需1个赞")])
                            ])
                      ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "division" }),
                _vm._v(" "),
                _c("div", { staticClass: "participated-bottom" }, [
                  _c("div", { staticClass: "participated-left" }, [
                    _c("img", {
                      attrs: {
                        src:
                          _vm.uncommitted[0].coverImg ||
                          require("../assets/img/default-coverimg.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "name" }, [
                      _vm._v(
                        _vm._s(
                          _vm.uncommitted[0].nickName ||
                            "用户" + _vm.openId.substring(_vm.openId.length - 6)
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "participated-right" }, [
                    _c("span", { staticClass: "share-nums" }, [
                      _vm._v(
                        "集星 | " +
                          _vm._s(
                            _vm.uncommitted[0].nums
                              ? _vm.tranNumber(_vm.uncommitted[0].nums || 0, 1)
                              : "-"
                          )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "ranking-nums" }, [
                      _vm._v(
                        "排行 | " +
                          _vm._s(
                            _vm.uncommitted[0].orderNum
                              ? _vm.tranNumber(
                                  _vm.uncommitted[0].orderNum || 0,
                                  1
                                )
                              : "-"
                          )
                      )
                    ])
                  ])
                ])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list" }, [
          _vm._m(1),
          _vm._v(" "),
          _vm.list.length > 0
            ? _c(
                "ul",
                { staticClass: "table-list" },
                [
                  _vm._l(_vm.list, function(item, index) {
                    return [
                      _c("li", { key: item.id, staticClass: "item" }, [
                        _c("p", { staticClass: "item-name" }, [
                          _c("img", {
                            attrs: {
                              src:
                                item.coverImg ||
                                require("../assets/img/default-coverimg.png"),
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                item.nickName ||
                                  "用户" +
                                    item.openId.substring(
                                      item.openId.length - 6
                                    )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "item-nums" }, [
                          _vm._v(_vm._s(_vm.tranNumber(item.nums || 0, 1)))
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "item-sort",
                            style: item.nums <= 0 ? "opacity: 0" : "opacity: 1"
                          },
                          [
                            index == 0
                              ? _c("img", {
                                  staticClass: "sort-img",
                                  attrs: {
                                    src: require("../assets/img/rankingimg/ranking-1.png"),
                                    alt: "1"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            index == 1
                              ? _c("img", {
                                  staticClass: "sort-img",
                                  attrs: {
                                    src: require("../assets/img/rankingimg/ranking-2.png"),
                                    alt: "2"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            index == 2
                              ? _c("img", {
                                  staticClass: "sort-img",
                                  attrs: {
                                    src: require("../assets/img/rankingimg/ranking-3.png"),
                                    alt: "3"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            index > 2
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.tranNumber(index + 1 || 0, 1))
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    ]
                  }),
                  _vm._v(" "),
                  _vm._m(2)
                ],
                2
              )
            : _c("div", { staticClass: "no-data-tip" }, [
                _vm.acquisitionTime != 3
                  ? _c("img", {
                      attrs: {
                        src: require("../assets/img/rankingimg/no-data.png"),
                        alt: "没数据"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.acquisitionTime != 3
                  ? _c("p", [_vm._v("暂无排名...")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.acquisitionTime == 3
                  ? _c("p", { staticClass: "tip-title" }, [
                      _vm._v("---飞鹤品鉴PK赛，赢千元大奖活动---")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.acquisitionTime == 3
                  ? _c("p", [_vm._v("即将开始，敬请期待。")])
                  : _vm._e()
              ])
        ])
      ]),
      _vm._v(" "),
      _vm.msgFlag
        ? _c("div", { staticClass: "msg" }, [
            _c("div", { staticClass: "msg-content" }, [_c("index-Msg")], 1),
            _vm._v(" "),
            _c("img", {
              staticClass: "close-msg",
              attrs: {
                src: require("../assets/img/rankingimg/close-icon.png"),
                alt: ""
              },
              on: {
                click: function($event) {
                  _vm.msgFlag = false
                }
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "md-popup",
        {
          attrs: { "mask-closable": false },
          model: {
            value: _vm.isPopupShow,
            callback: function($$v) {
              _vm.isPopupShow = $$v
            },
            expression: "isPopupShow"
          }
        },
        [
          _c("div", { staticClass: "register-box" }, [
            _c(
              "div",
              { staticClass: "register-info" },
              [
                _c(
                  "md-input-item",
                  {
                    ref: "input0",
                    staticClass: "register-item",
                    attrs: {
                      title: "",
                      placeholder: "姓名",
                      type: "text",
                      maxlength: 10
                    },
                    model: {
                      value: _vm.registerinfo.name,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.registerinfo,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "registerinfo.name"
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "name-icon",
                      attrs: { slot: "left" },
                      slot: "left"
                    })
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "register-item register-item-native" }, [
                  _c("span", { staticClass: "phone-icon" }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.registerinfo.phone,
                        expression: "registerinfo.phone"
                      }
                    ],
                    attrs: {
                      type: "tel",
                      placeholder: "手机号",
                      maxlength: "11"
                    },
                    domProps: { value: _vm.registerinfo.phone },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.registerinfo,
                            "phone",
                            $event.target.value
                          )
                        },
                        function($event) {
                          _vm.registerinfo.phone = _vm.registerinfo.phone.replace(
                            /[^\d]/g,
                            ""
                          )
                        }
                      ],
                      focus: function($event) {
                        return _vm.inpFocus()
                      },
                      blur: function($event) {
                        return _vm.inpBlur()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "register-item register-item-native" }, [
                  _c("span", { staticClass: "verification-icon" }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.registerinfo.verification,
                        expression: "registerinfo.verification"
                      }
                    ],
                    attrs: {
                      type: "tel",
                      placeholder: "验证码",
                      maxlength: "6"
                    },
                    domProps: { value: _vm.registerinfo.verification },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.registerinfo,
                            "verification",
                            $event.target.value
                          )
                        },
                        function($event) {
                          _vm.registerinfo.verification = _vm.registerinfo.verification.replace(
                            /[^\d]/g,
                            ""
                          )
                        }
                      ],
                      focus: function($event) {
                        return _vm.inpFocus()
                      },
                      blur: function($event) {
                        return _vm.inpBlur()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.countdown == 60
                    ? _c(
                        "span",
                        {
                          staticClass: "getverification-btn",
                          class: { "disabled-btn": !_vm.registerinfo.phone },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.getverification($event)
                            }
                          }
                        },
                        [_vm._v("获取验证码")]
                      )
                    : _c(
                        "span",
                        { staticClass: "getverification-btn disabled-btn" },
                        [_vm._v(_vm._s(_vm.countdown) + "s")]
                      )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "confrim-btn",
                    class: {
                      "disabled-confrim-btn":
                        !_vm.registerinfo.name ||
                        !_vm.registerinfo.phone ||
                        !_vm.registerinfo.verification ||
                        !_vm.isChecked
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../assets/img/rankingimg/register-confrim1.png"),
                        alt: ""
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.confrimregister($event)
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "infor_agreement" }, [
                  !_vm.isChecked
                    ? _c("img", {
                        attrs: {
                          src: require("../assets/img/rankingimg/no-checked.png"),
                          alt: ""
                        },
                        on: {
                          click: function($event) {
                            _vm.isChecked = true
                          }
                        }
                      })
                    : _c("img", {
                        attrs: {
                          src: require("../assets/img/rankingimg/checked.png"),
                          alt: ""
                        },
                        on: {
                          click: function($event) {
                            _vm.isChecked = false
                          }
                        }
                      }),
                  _vm._v(" "),
                  _c("span", { staticClass: "infor_explain" }, [
                    _vm._v("注册即同意"),
                    _c("a", { on: { click: _vm.goregisterAgreement } }, [
                      _vm._v("用户协议及隐私政策")
                    ]),
                    _vm._v("，请仔细阅读说明")
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "close-box" }, [
              _c("img", {
                attrs: {
                  src: require("../assets/img/rankingimg/close-icon.png"),
                  alt: ""
                },
                on: {
                  click: function($event) {
                    _vm.isPopupShow = false
                  }
                }
              })
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ucontainer-right" }, [
      _c("p", [
        _vm._v("\n                      集星 | "),
        _c("span", [_vm._v("-")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n                      排行 | "),
        _c("span", [_vm._v("-")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table-title" }, [
      _c("span", [_vm._v("昵称")]),
      _vm._v(" "),
      _c("span", [_vm._v("集星总量")]),
      _vm._v(" "),
      _c("span", [_vm._v("排行")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "list-tips" }, [
      _c("span", [_vm._v("--已经到底--")]),
      _vm._v(" "),
      _c("span", [_vm._v("仅显示前50名")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-656ac063", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-656ac063","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/rankingList.vue
// module id = null
// module chunks = 